<template>
  <ul
    class="oct-tabs"
    role="tablist"
  >
    <oct-tab-item
      class="oct-tabs__item"
      v-for="(item, i) in items"
      :key="i"
      :text="item.text"
      :selected="item.selected"
      @click.native.stop="$emit('click:item', i)"
    />
  </ul>
</template>

<script>
import OctTabItem from '@/components/tabs/OctTabItem.vue'

export default {
  name: 'OctTabs',
  components: {
    OctTabItem
  },
  props: {
    /** Tabs */
    items: {
      type: Array,
      default () {
        return []
      }
    },
  }
}
</script>

<style scoped lang="scss">
@import "../theme/variables";
@import "../grid/variables";
@import "../typography/variables";
@import "../typography/mixins";

.oct-tabs {
  display: flex;
  margin: 0;
}
</style>
